
import { articleDetail } from '@/api/api'
import router from '@/router'
import { defineComponent, onMounted, ref, watch } from 'vue'
import axios from 'axios'

export default defineComponent({
  name: 'ArticleDetail',
  components: {},
  setup () {
    const routerPath = ref<any>([])
    const articleObj = ref<any>({})
    onMounted(() => {
      const code = router.currentRoute.value.query.code
      const id = router.currentRoute.value.query.id
      articleDetail({ code: code, id: id }).then((res: any) => {
        if (res) {
          routerPath.value = res.category.treeNames.split('/')
          articleObj.value = res
          // let content = res.article.articleData.content
          // content = content.replace(
          //   /src="\/userfiles/g,
          //   'src="' + axios.defaults.baseURL + '/userfiles'
          // )
          // articleObj.value.article.articleData.content = content
        }
      })
    })
    watch(
      () => router.currentRoute.value.query,
      () => {
        const code = router.currentRoute.value.query.code
        const id = router.currentRoute.value.query.id
        articleDetail({ code: code, id: id }).then((res: any) => {
          if (res) {
            routerPath.value = res.category.treeNames.split('/')
            articleObj.value = res
          }
        })
      }
    )
    return {
      articleObj,
      routerPath
    }
  }
})
